// extracted by mini-css-extract-plugin
export default {"center":"denied-access-page_center__oDUCC"};